import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './view/header/header.component';
import { HomeComponent } from './view/home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FooterComponent } from './view/footer/footer.component';
import { SliderComponent } from './view/header/slider/slider.component';
import { FormsModule } from '@angular/forms';
import { ShowcaseComponent } from './view/home/showcase/showcase.component';
import { SharedModule } from './modules/shared/shared.module';
import { BulletinComponent } from './view/home/bulletin/bulletin.component';
import { AboutComponent } from './view/home/about/about.component';
import { WhyComponent } from './view/home/why/why.component';
import { MemberComponent } from './view/home/about/member/member.component';
import { AchievementComponent } from './view/home/achievement/achievement.component';
import { MapComponent } from './view/footer/map/map.component';
import { ScrollingComponent } from './view/scrolling/scrolling.component';
import { PointsComponent } from './view/home/about/points/points.component';
import { FacilitiesComponent } from './view/home/facilities/facilities.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { TestimonialComponent } from './view/home/testimonial/testimonial.component';
import { AccomplishmentModule } from './modules/accomplishment/accomplishment.module';
import { LazyloadDirective } from './directives/lazyload.directive';
import { FacultyModule } from './modules/faculty/faculty.module';
import { CampusModule } from './modules/campus/campus.module';
import { GlimpsesModule } from './modules/glimpses/glimpses.module';
import { AchievementsModule } from './modules/achievements/achievements.module';
import { AdmissionModule } from './modules/admission/admission.module';
import { ContactUsComponent } from './view/contact-us/contact-us.component';
import { AngularFireModule } from 'angularfire2';
import { environment } from 'src/environments/environment';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { GalleryModule } from './modules/gallery/gallery.module';
import { MenuComponent } from './view/home/menu/menu.component';
import { NewShowcaseComponent } from './view/home/new-showcase/new-showcase.component';
import { CbseComponent } from './view/cbse/cbse.component';
import { JsShowcaseComponent } from './view/home/js-showcase/js-showcase.component';
import { ClickOutsideDirective } from './directives/click-outside/click-outside.directive';
import { NewFooterComponent } from './view/new-footer/new-footer.component';
import { EventsComponent } from './view/home/events/events.component';
import { BlogComponent } from './view/home/blog/blog.component';
import { BlogItemComponent } from './view/home/blog/blog-item/blog-item.component';
import { AboutModule } from './modules/about/about.module';
import { LabsModule } from './modules/labs/labs.module';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { ImagesComponent } from './view/home/images/images.component';
import { RefundComponent } from './view/refund/refund.component';
import { PrivacyComponent } from './view/privacy/privacy.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    FooterComponent,
    SliderComponent,
    ShowcaseComponent,
    BulletinComponent,
    AboutComponent,
    WhyComponent,
    MemberComponent,
    AchievementComponent,
    MapComponent,
    ScrollingComponent,
    PointsComponent,
    FacilitiesComponent,
    TestimonialComponent,
    LazyloadDirective,
    ContactUsComponent,
    MenuComponent,
    NewShowcaseComponent,
    CbseComponent,
    JsShowcaseComponent,
    ClickOutsideDirective,
    NewFooterComponent,
    EventsComponent,
    BlogComponent,
    BlogItemComponent,
    ImagesComponent,
    RefundComponent,
    PrivacyComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    SharedModule,
    CarouselModule,
    AccomplishmentModule,
    FacultyModule,
    CampusModule,
    GlimpsesModule,
    AchievementsModule,
    AdmissionModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireDatabaseModule,
    AngularFirestoreModule,
    GalleryModule,
    AboutModule,
    LabsModule,
    Ng2SearchPipeModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
